import React, { useContext, useState } from "react";
import { CartContext } from "./CartContext";
import "../css/checkout.css";
import productData from "../Datas/productData";
import { Link } from "react-router-dom";
import ReactFlagsSelect from "react-flags-select";

const SHIPPING = 9.99;
const RESTRICTED_COUNTRIES = ["AF", "BY", "CU", "IR", "KP", "RU", "SY"];

const CheckOut = () => {
  const { cartItems } = useContext(CartContext);
  const [form, setForm] = useState({ email: "", country: "", firstName: "", lastName: "", company: "", address: "", address2: "", city: "", postalCode: "" });

  const update = (key) => (event) => setForm((value) => ({ ...value, [key]: event.target.value }));
  const getProduct = (id) => productData.find((product) => product.id === id);
  const subtotal = cartItems.reduce((total, item) => {
    const product = getProduct(item.id);
    return product ? total + Number(product.variantPrices?.[item.size] || product.price) * item.quantity : total;
  }, 0);
  const total = subtotal + SHIPPING;

  const handlePlaceOrder = (event) => {
    event.preventDefault();
    const required = ["email", "country", "firstName", "lastName", "address", "city", "postalCode"];
    if (!cartItems.length || required.some((field) => !form[field].trim())) {
      window.alert(cartItems.length ? "Please complete all required delivery fields." : "Your cart is empty.");
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
      window.alert("Please enter a valid email address.");
      return;
    }

    const firstProduct = getProduct(cartItems[0].id);
    const origin = window.location.origin;
    const randomPart = window.crypto?.getRandomValues
      ? Array.from(window.crypto.getRandomValues(new Uint32Array(3))).join("")
      : `${Date.now()}${Math.floor(Math.random() * 1000000)}`;
    const params = new URLSearchParams({
      orderNo: `${Date.now()}${randomPart}`.slice(0, 30),
      amount: total.toFixed(2),
      currency: "USD",
      email: form.email,
      success_url: `${origin}/payment?state=success`,
      cancel_url: `${origin}/payment?state=cancel`,
      title: firstProduct?.name || "autumncircle order",
    });
    window.location.assign(`${origin}/create_payment.php?${params.toString()}`);
  };

  return (
    <main className="main-containerCheck">
      <div className="check-custom-checkout-page">
        <div className="left">
          <div className="check-order-info">
            <form onSubmit={handlePlaceOrder}>
              <div className="form-group"><label htmlFor="email">Email</label><input id="email" type="email" value={form.email} onChange={update("email")} placeholder="Email address" required /></div>
              <div className="form-group"><label>Delivery country or region</label><ReactFlagsSelect selected={form.country} onSelect={(country) => setForm((value) => ({ ...value, country }))} countries={RESTRICTED_COUNTRIES} blacklistCountries className="check-select" searchable /></div>
              <div className="form-row">
                <div className="form-group"><input value={form.firstName} onChange={update("firstName")} placeholder="First name *" required /></div>
                <div className="form-group"><input value={form.lastName} onChange={update("lastName")} placeholder="Last name *" required /></div>
              </div>
              <div className="form-group"><input value={form.company} onChange={update("company")} placeholder="Company name (optional)" /></div>
              <div className="form-group"><input value={form.address} onChange={update("address")} placeholder="Address *" required /></div>
              <div className="form-group"><input value={form.address2} onChange={update("address2")} placeholder="Apartment, suite, etc. (optional)" /></div>
              <div className="form-row">
                <div className="form-group"><input value={form.city} onChange={update("city")} placeholder="City *" required /></div>
                <div className="form-group"><input value={form.postalCode} onChange={update("postalCode")} placeholder="Postal code *" required /></div>
              </div>
              <div className="form-group"><label>Shipping method</label><div className="payment-box"><div className="payment-header"><span>Standard tracked shipping</span><strong>$9.99</strong></div></div></div>
              <button type="submit" className="check-checkout-button">Pay Now</button>
            </form>
            <p><Link to="/returns" style={{ textDecoration: "underline" }}>Shipping & Returns Info</Link></p>
          </div>
        </div>
        <div className="right">
          <div className="check-order-summary"><div className="check-order-details">
            {cartItems.map((item, index) => { const product = getProduct(item.id); const unitPrice = product ? Number(product.variantPrices?.[item.size] || product.price) : 0; return product ? <div key={`${item.id}-${index}`} className="check-cart-item"><img src={product.image} alt={product.name} /><div className="pro--qty"><div className="qty-inner">{item.quantity}</div></div><div className="check-item-details"><h3>{product.name}</h3></div><p className="cal-single">${(unitPrice * item.quantity).toFixed(2)}</p></div> : null; })}
            <div className="check-summary-details"><p>Subtotal <span>${subtotal.toFixed(2)}</span></p><p>Shipping <span>${SHIPPING.toFixed(2)}</span></p><div className="gridTotal"><table className="summary-details22"><tbody className="sumTbody22"><tr className="sumTr22"><th className="subtotalTh22" style={{ fontSize: "24px" }}>Total</th><th className="subtotalTxt22">${total.toFixed(2)} USD</th></tr></tbody></table></div></div>
          </div></div>
        </div>
      </div>
    </main>
  );
};

export default CheckOut;
